/** @TJS-type number */
export class UserId {
    private constructor() {
    }

    "UserId": UserId;

    public static wrap(id: number): UserId {
        return <any>id;
    }

    public static unwrap(userId: UserId): number {
        return <any>userId;
    }
}

/** @TJS-type number */
export class AgencyId {
    private constructor() {
    }

    "AgencyId": AgencyId;

    public static wrap(id: number): AgencyId {
        return <any>id;
    }

    public static unwrap(agencyId: AgencyId): number {
        return <any>agencyId;
    }
}

/** @TJS-type number */
export class CaregiverNotificationId {
    private constructor() {
    }

    "CaregiverNotificationId": CaregiverNotificationId;

    public static wrap(id: number): CaregiverNotificationId {
        return <any>id;
    }

    public static unwrap(caregiverNotificationId: CaregiverNotificationId): number {
        return <any>caregiverNotificationId;
    }
}

/** @TJS-type number */
export class AgencyMemberId {
    private constructor() {
    }

    "AgencyMemberId": AgencyMemberId;

    public static wrap(id: number): AgencyMemberId {
        return <any>id;
    }

    public static unwrap(agencyMemberId: AgencyMemberId): number {
        return <any>agencyMemberId;
    }
}

/** @TJS-type number */
export class VisitId {
    private constructor() {
    }

    "VisitId": VisitId;

    public static wrap(id: number): VisitId {
        return <any>id;
    }

    public static unwrap(visitId: VisitId): number {
        return <any>visitId;
    }
}

/** @TJS-type number */
export class ImportedVisitId {
    private constructor() {
    }

    "ImportedVisitId": ImportedVisitId;

    public static wrap(id: number): ImportedVisitId {
        return <any>id;
    }

    public static unwrap(importedVisitId: ImportedVisitId): number {
        return <any>importedVisitId;
    }
}

/** @TJS-type number */
export class ScheduledVisitId {
    private constructor() {
    }

    "ScheduledVisitId": ScheduledVisitId;

    public static wrap(id: number): ScheduledVisitId {
        return <any>id;
    }

    public static unwrap(scheduledVisitId: ScheduledVisitId): number {
        return <any>scheduledVisitId;
    }
}

/** @TJS-type number */
export class ScheduledVisitEditRequestId {
    private constructor() {
    }

    "ScheduledVisitEditRequestId": ScheduledVisitEditRequestId;

    public static wrap(id: number): ScheduledVisitEditRequestId {
        return <any>id;
    }

    public static unwrap(scheduledVisitEditRequestId: ScheduledVisitEditRequestId): number {
        return <any>scheduledVisitEditRequestId;
    }
}

/** @TJS-type number */
export class CaregiverVisitEngagementId {
    private constructor() {
    }

    "CaregiverVisitEngagementId": CaregiverVisitEngagementId;

    public static wrap(id: number): CaregiverVisitEngagementId {
        return <any>id;
    }

    public static unwrap(caregiverVisitEngagementId: CaregiverVisitEngagementId): number {
        return <any>caregiverVisitEngagementId;
    }
}

/** @TJS-type number */
export class CaregiverId {
    private constructor() {
    }

    "CaregiverId": CaregiverId;

    public static wrap(id: number): CaregiverId {
        return <any>id;
    }

    public static unwrap(caregiverId: CaregiverId): number {
        return <any>caregiverId;
    }
}

/** @TJS-type number */
export class CaregiverPhonenumberId {
    private constructor() {
    }

    "CaregiverPhonenumberId": CaregiverPhonenumberId;

    public static wrap(id: number): CaregiverPhonenumberId {
        return <any>id;
    }

    public static unwrap(val: CaregiverPhonenumberId): number {
        return <any>val;
    }
}

/** @TJS-type number */
export class CaregiverLastSeenId {
    private constructor() {
    }

    "CaregiverLastSeenId": CaregiverLastSeenId;

    public static wrap(id: number): CaregiverLastSeenId {
        return <any>id;
    }

    public static unwrap(caregiverLastSeenId: CaregiverLastSeenId): number {
        return <any>caregiverLastSeenId;
    }
}

/** @TJS-type number */
export class CaregiverAgencyAssocId {
    private constructor() {
    }

    "CaregiverAgencyAssocId": CaregiverAgencyAssocId;

    public static wrap(id: number): CaregiverAgencyAssocId {
        return <any>id;
    }

    public static unwrap(caregiverAgencyAssocId: CaregiverAgencyAssocId): number {
        return <any>caregiverAgencyAssocId;
    }
}

/** @TJS-type number */
export class ChatRoomId {
    private constructor() {
    }

    "ChatRoomId": ChatRoomId;

    public static wrap(id: number): ChatRoomId {
        return <any>id;
    }

    public static unwrap(val: ChatRoomId): number {
        return <any>val;
    }
}

/** @TJS-type number */
export class ChatMessageId {
    private constructor() {
    }

    "ChatMessageId": ChatMessageId;

    public static wrap(id: number): ChatMessageId {
        return <any>id;
    }

    public static unwrap(val: ChatMessageId): number {
        return <any>val;
    }
}

/** @TJS-type number */
export class ChatMessageViewedId {
    private constructor() {
    }

    "ChatMessageViewedId": ChatMessageViewedId;

    public static wrap(id: number): ChatMessageViewedId {
        return <any>id;
    }

    public static unwrap(val: ChatMessageViewedId): number {
        return <any>val;
    }
}

/** @TJS-type number */
export class VisitChatRoomId {
    private constructor() {
    }

    "VisitChatRoomId": VisitChatRoomId;

    public static wrap(id: number): VisitChatRoomId {
        return <any>id;
    }

    public static unwrap(val: VisitChatRoomId): number {
        return <any>val;
    }
}

/** @TJS-type number */
export class AgencyMemberCaregiverChatRoomId {
    private constructor() {
    }

    "AgencyMemberCaregiverChatRoomId": AgencyMemberCaregiverChatRoomId;

    public static wrap(id: number): AgencyMemberCaregiverChatRoomId {
        return <any>id;
    }

    public static unwrap(val: AgencyMemberCaregiverChatRoomId): number {
        return <any>val;
    }
}

/** @TJS-type number */
export class InternalAgencyChatRoomId {
    private constructor() {
    }

    "InternalAgencyChatRoomId": InternalAgencyChatRoomId;

    public static wrap(id: number): InternalAgencyChatRoomId {
        return <any>id;
    }

    public static unwrap(val: InternalAgencyChatRoomId): number {
        return <any>val;
    }
}

/** @TJS-type number */
export class SendSmsJobId {
    private constructor() {
    }

    "SendSmsJobId": SendSmsJobId;

    public static wrap(id: number): SendSmsJobId {
        return <any>id;
    }

    public static unwrap(val: SendSmsJobId): number {
        return <any>val;
    }
}

/** @TJS-type number */
export class UserFcmRegistrationTokenId {
    private constructor() {
    }

    "UserFcmRegistrationTokenId": UserFcmRegistrationTokenId;

    public static wrap(id: number): UserFcmRegistrationTokenId {
        return <any>id;
    }

    public static unwrap(val: UserFcmRegistrationTokenId): number {
        return <any>val;
    }
}

/** @TJS-type number */
export class FcmJobQueueId {
    private constructor() {
    }

    "FcmJobQueueId": FcmJobQueueId;

    public static wrap(id: number): FcmJobQueueId {
        return <any>id;
    }

    public static unwrap(val: FcmJobQueueId): number {
        return <any>val;
    }
}

/** @TJS-type number */
export class UploadJobId {
    private constructor() {
    }

    "UploadJobId": UploadJobId;

    public static wrap(id: number): UploadJobId {
        return <any>id;
    }

    public static unwrap(val: UploadJobId): number {
        return <any>val;
    }
}

/** @TJS-type number */
export class HRQuestionId {
    private constructor() {
    }

    "HRQuestionId": HRQuestionId;

    public static wrap(id: number): HRQuestionId {
        return <any>id;
    }

    public static unwrap(val: HRQuestionId): number {
        return <any>val;
    }
}

/** @TJS-type string */
export class HRQuestionTemplateId {
    private constructor() {
    }

    "HRQuestionTemplateId": HRQuestionTemplateId;

    public static wrap(id: string): HRQuestionTemplateId {
        return <any>id;
    }

    public static unwrap(val: HRQuestionTemplateId): string {
        return <any>val;
    }
}


/** @TJS-type number */
export class HRSectionId {
    private constructor() {
    }

    "HRSectionId": HRSectionId;

    public static wrap(id: number): HRSectionId {
        return <any>id;
    }

    public static unwrap(val: HRSectionId): number {
        return <any>val;
    }
}

/** @TJS-type number */
export class HRSubSectionId {
    private constructor() {
    }

    "HRSubSectionId": HRSubSectionId;

    public static wrap(id: number): HRSubSectionId {
        return <any>id;
    }

    public static unwrap(val: HRSubSectionId): number {
        return <any>val;
    }
}

/** @TJS-type number */
export class HRQuestionGroupId {
    private constructor() {
    }

    "HRQuestionGroup": HRQuestionGroupId;

    public static wrap(id: number): HRQuestionGroupId {
        return <any>id;
    }

    public static unwrap(val: HRQuestionGroupId): number {
        return <any>val;
    }
}

/** @TJS-type number */
export class HRDocumentId {
    private constructor() {
    }

    "HRDocumentId": HRDocumentId;

    public static wrap(id: number): HRDocumentId {
        return <any>id;
    }

    public static unwrap(val: HRDocumentId): number {
        return <any>val;
    }
}

/** @TJS-type number */
export class HRDocumentTypeId {
    private constructor() {
    }

    "HRDocumentTypeId": HRDocumentTypeId;

    public static wrap(id: number): HRDocumentTypeId {
        return <any>id;
    }

    public static unwrap(val: HRDocumentTypeId): number {
        return <any>val;
    }
}

/** @TJS-type number */
export class HRSectionStageId {
    private constructor() { }

    "HRSectionStageId": HRSectionStageId;

    public static wrap(id: number): HRSectionStageId {
        return <any>id;
    }

    public static unwrap(val: HRSectionStageId): number {
        return <any>val;
    }
}

/** @TJS-type number */
export class CaregiverDocumentTypeId {
    private constructor() { }

    "CaregiverDocumentTypeId": CaregiverDocumentTypeId;

    public static wrap(id: number): CaregiverDocumentTypeId {
        return <any>id;
    }

    public static unwrap(val: CaregiverDocumentTypeId): number {
        return <any>val;
    }
}

/** @TJS-type number */
export class OfficeId {
    private constructor() { }

    "OfficeId": OfficeId;

    public static wrap(id: number): OfficeId {
        return <any>id;
    }

    public static unwrap(officeId: OfficeId): number {
        return <any>officeId;
    }
}

/** @TJS-type number */
export class PayRateSupplementalId {
    private constructor() { }

    "PayRateSupplementalId": PayRateSupplementalId;

    public static wrap(id: number): PayRateSupplementalId {
        return <any>id;
    }

    public static unwrap(val: PayRateSupplementalId): number {
        return <any>val;
    }
}

/** @TJS-type string */
export class CaregiverCertification {
    private constructor() { }

    "CaregiverCertification": CaregiverCertification;

    public static wrap(name: string): CaregiverCertification {
        return <any>name;
    }

    public static unwrap(val: CaregiverCertification): string {
        return <any>val;
    }
}



// WEBPACK FOOTER //
// ./src/messages/ObjectIds.ts